/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Analyze_BtnInputs */

const en_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

const de_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

const fr_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

const es_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

const it_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

const nl_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

const pl_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

const fi_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

const da_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

const sv_deep_match_analyze_btn = /** @type {(inputs: Deep_Match_Analyze_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Match`)
};

/**
* | output |
* | --- |
* | "Analyze Match" |
*
* @param {Deep_Match_Analyze_BtnInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_analyze_btn = /** @type {((inputs?: Deep_Match_Analyze_BtnInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Analyze_BtnInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_analyze_btn(inputs)
	if (locale === "fr") return fr_deep_match_analyze_btn(inputs)
	if (locale === "es") return es_deep_match_analyze_btn(inputs)
	if (locale === "it") return it_deep_match_analyze_btn(inputs)
	if (locale === "nl") return nl_deep_match_analyze_btn(inputs)
	if (locale === "pl") return pl_deep_match_analyze_btn(inputs)
	if (locale === "fi") return fi_deep_match_analyze_btn(inputs)
	if (locale === "da") return da_deep_match_analyze_btn(inputs)
	if (locale === "sv") return sv_deep_match_analyze_btn(inputs)
	return en_deep_match_analyze_btn(inputs)
});